$(document).ready(function() {
  /**
   * Update stamped badges for accessibility:
   *  - remove aria-label from the visual badge container
   *  - set aria-label on the caption using the rating value
   */
  function updateStampedBadges() {
    $('.stamped-product-reviews-badge .stamped-badge').each(function() {
      const $badge = $(this);

      // Remove any aria-label from the badge itself
      $badge.removeAttr('aria-label');

      // Find the caption inside this badge
      const $caption = $badge.find('.stamped-badge-caption');
      if ($caption.length) {
        // Prefer rating from caption, fall back to badge data-rating
        const ratingAttr = $caption.attr('data-rating') || $badge.attr('data-rating');
        if (ratingAttr) {
          const rating = parseFloat(ratingAttr);
          if (!isNaN(rating)) {
            // Round to one decimal place, e.g. 4.4
            const roundedRating = Math.round(rating * 10) / 10;
            const ariaLabel = 'Rating: ' + roundedRating + ' out of 5 stars';
            $caption.attr('aria-label', ariaLabel);
            $caption.attr('role', 'img');
          }
        }
      }
    });
  }

  // Run once on initial load in case badges are already present
  updateStampedBadges();

  // Create a MutationObserver to watch for changes in the DOM
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      // Check if the added nodes contain the .stamped-badge
      mutation.addedNodes.forEach(function(node) {
        if (node.nodeType === 1 && $(node).is('.stamped-product-reviews-badge .stamped-badge')) {
          updateStampedBadges();

          // After updating, disconnect the observer to stop watching
          observer.disconnect();
        }
      });
    });
  });

  // Set up the observer on the document body (or any container where the badge is added)
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});
